import { render } from "./AppBaseSheetMenuItem.vue?vue&type=template&id=5b67f81f&scoped=true"
import script from "./AppBaseSheetMenuItem.vue?vue&type=script&lang=js"
export * from "./AppBaseSheetMenuItem.vue?vue&type=script&lang=js"

import "./AppBaseSheetMenuItem.vue?vue&type=style&index=0&id=5b67f81f&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b67f81f"]])

export default __exports__